/**
 * Formats a number as a currency string in USD
 * @param value - The number to format as currency (can be null or undefined)
 * @returns A formatted currency string (e.g., "$1,234") or "—" for null/undefined values
 * @example
 * formatCurrency(1234) // "$1,234"
 * formatCurrency(1000000) // "$1,000,000"
 * formatCurrency(null) // "—"
 */

export function formatCurrency(value: number | null | undefined): string {
  if (value === undefined || value === null) return "—";

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formatter.format(value);
}
